///? Default IMPORTS
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

///? Service IMPORTS
import { getOrderDetailsThunk } from "../../redux/NewOrderDetails/action";

///? Component & Styling IMPORTS
import { message } from "antd";
import { Base64func } from "../../components/Base64Func/Base64func";
import OfflinePage from "../OfflinePage/OfflinePage";
import OrderDetails from "../../components/OrderDetailSection/OrderDetails";
import { FiPackage } from "react-icons/fi";
import BarcodeScanner from "../../components/BarcodeScanner/BarcodeScanner";
import { warehouseId } from "../../constants";

///? Constants
message.config({
  maxCount: 1,
});

export class PackerPage extends Component {
  state = {
    currentOrderId: null,
    currentOrderData: null,
    showScannerScreen: false,
    serviceLoading: false,
  };

  componentDidMount() {
    message.loading("Loading", 0);

    //? Getting order ID from url

    let currPath = window.location.href;

    let currPathArr = currPath.split("/");
    let orderValue = "";

    currPathArr.map((item) =>
      item.includes("orderId") ? (orderValue = item.split("=")[1]) : ""
    );

    this.setState(
      {
        currentOrderId: Base64func(orderValue, "decode"),
        serviceLoading: true,
      },
      () => {
        message.destroy();
        //* Checker order update service here
        //* if we don't find any error there then this service below
        let data = {
          orderId: this.state.currentOrderId,
          // orderId: 940,
          warehouseId: warehouseId,
          access_token: this.props.access_token,
          history: this.props.history,
        };

        //? Packer order update service here will replace once it is done
        this.props.getOrderDetailsThunk(data).then(() => {
          message.destroy();
          if (this.props.newOrderDetails?.newOrderDetailsError) {
            message.error(this.props.newOrderDetails?.newOrderDetailsError);
          } else {
            this.setState({
              currentOrderData: this.props.newOrderDetails
                .newOrderDetailsSuccess,
              serviceLoading: false,
            });
          }
        });
      }
    );
  }

  changeBoxModal = (value) => {
    this.setState({ showScannerScreen: value });
  };

  updateBoxId = (value) => {
    if (value) {
      let updateBox = this.state.currentOrderData;
      updateBox["boxNumber"] = value;
      this.setState({ currentOrderData: updateBox });
    }

    this.setState({ showScannerScreen: false });
  };

  packOrderFunc = () => {
    // message.loading("Loading...", 0);

    // setTimeout(() => {
    //   message.destroy();
    //   this.props.history.push("/packer");
    // }, 2000);
    this.props.history.push("/packer");
  };

  render() {
    return (
      <div className="centerScreen">
        {this.props.isOnline ? (
          <>
            <OrderDetails
              orderId={this.state.currentOrderId}
              customerName={this.state.currentOrderData?.customerName}
              invoiceDate={this.state.currentOrderData?.invoiceDate}
              paymentType={this.state.currentOrderData?.paymentType}
              orderValue={this.state.currentOrderData?.orderValue}
              boxId={this.state.currentOrderData?.boxNumber}
              updateBox={this.changeBoxModal}
              isLoading={this.state.serviceLoading}
            />

            {this.state.showScannerScreen && (
              <BarcodeScanner
                scan={this.state.showScannerScreen ? true : false}
                camera={this.state.showScannerScreen ? true : false}
                orderId={this.state.currentOrderId}
                // orderId={940}
                history={this.props.history}
                getBoxId={this.updateBoxId}
              />
            )}

            <button className="bbtn" onClick={() => this.packOrderFunc()}>
              <FiPackage /> Pack Order
            </button>
          </>
        ) : (
          <OfflinePage />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  newOrderDetails: state.newOrderDetailsReducer,
});

export default withRouter(
  connect(mapStateToProps, {
    getOrderDetailsThunk,
  })(PackerPage)
);
